module.exports = __webpack_public_path__ + "assets/img/title-0fbaa2dd.png";